// Helper functions relating to the restricted dates functionality

export const getRestrictionMessage = (restriction) => {
  return restriction.custom_message && restriction.custom_message != ""
    ? restriction.custom_message
    : `Your selected arrival date has a minimum ${restriction.min_nights}-night stay policy, so some availability may not show. To view all rates, please change your date selection and try again.`;
};
